<script lang="jsx">
import Base from '../config.vue';
import EditSimple from './edit-simple.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.edit && this.$context.is.simplify) {
      return <EditSimple />;
    }

    return <Base />;
  },
};
</script>
